import { NavItem, NavItemType } from "@bagel-web/components";
import { CurrentUser } from "api/types";
import { useEffect, useState } from "react";

export const useNavConfig = ({
  whoAmI,
}: {
  whoAmI: CurrentUser | null;
}): NavItem[] => {
  const [showUsers, setShowUsers] = useState(false);

  useEffect(() => {
    if (whoAmI?.permissions?.includes("widgets:users-table:manage")) {
      setShowUsers(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [whoAmI?.id]);

  return [
    {
      type: NavItemType.LINK,
      href: "/organizations",
      iconClassName: "bi-building-fill",
      label: "Organizations",
    },
    ...(showUsers
      ? [
          {
            type: NavItemType.LINK,
            href: "/users",
            iconClassName: "bi-people-fill",
            label: "Users",
          },
        ]
      : []),
    {
      type: NavItemType.LINK,
      href: "/services",
      iconClassName: "bi-cpu-fill",
      label: "Service Aliases",
    },
    {
      type: NavItemType.LINK,
      href: "/sessions",
      iconClassName: "bi-clock-history",
      label: "Sessions",
    },
    {
      type: NavItemType.LINK,
      href: "/chalk-logs",
      iconClassName: "bi-receipt-cutoff",
      label: "Chalk Logs",
    },
    {
      type: NavItemType.LINK,
      href: "/api-requests",
      iconClassName: "bi-arrow-left-right",
      label: "API Requests",
    },
    {
      type: NavItemType.LINK,
      href: "/feature-flags",
      iconClassName: "bi-flag-fill",
      label: "Feature Flags",
    },
    {
      type: NavItemType.LINK,
      href: "/model-usage",
      iconClassName: "bi-bar-chart-line-fill",
      label: "Model Usage",
    },
    {
      type: NavItemType.LINK,
      href: "/platform-tools",
      iconClassName: "bi-tools",
      label: "Platform Tools",
    },
    {
      type: NavItemType.LINK,
      href: "/documentation",
      iconClassName: "bi-journals",
      label: "Docs",
    },
  ];
};

export const getIsActive = (pathname: string) => (navItem: NavItem) => {
  return Boolean(
    navItem.type === NavItemType.LINK &&
    (pathname?.startsWith(navItem.href) ||
      (navItem.isRootPath && pathname === "/"))
  );
};
